import { render, staticRenderFns } from "./SubmenuContent.vue?vue&type=template&id=4b258916&scoped=true"
import script from "./SubmenuContent.vue?vue&type=script&lang=js"
export * from "./SubmenuContent.vue?vue&type=script&lang=js"
import style0 from "./SubmenuContent.vue?vue&type=style&index=0&id=4b258916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b258916",
  null
  
)

export default component.exports